import { Component, Input } from '@angular/core';
import { SideNavigationItem } from '../atlas_sdk/api';

@Component({
  selector: 'atlas-bc-nav-item',
  templateUrl: './bc-nav-item.component.html',
  styleUrls: ['./bc-nav-item.component.scss']
})
export class BcNavItemComponent {
  @Input() indentation: number = 0;
  @Input() sideNavigationItem: SideNavigationItem;
}
